<template>
  <div class="basic register-entrance">
    <div class="basic-header" style="margin-bottom:30px">
      <p>- 展区选择 Exhibition Selection -</p>
    </div>
    <div class="tabs">
      <div class="tabs-top">
        <Row :gutter="40">
          <Col span="6" v-for="(item, index) in area1" :key="index">
          <el-tooltip :content="item.name + ' ' + item.nameEn" placement="top" >
            <div class="tag" :class="{ active: areaIndex === index }" @click="areaName = item.name; areaIndex = index">
              <span>{{ item.name }} {{ item.nameEn }}</span>
            </div>
          </el-tooltip>
          </Col>
        </Row>
      </div>
      <div class="tabs-bottom" v-if="area1.length && area1[areaIndex].childrens">
        <Row :gutter="16">
          <Col span="6" v-for="(item, index) in area1[areaIndex].childrens" :key="index">
          <div class="item" :title="item.name" :class="{ active: selectTypeArr && selectTypeArr.name === item.name }"
            @click="addType(item)">{{ item.name }} {{ item.nameEn }}</div>
          </Col>
        </Row>
      </div>
    </div>

    <div class="choice">
      <Row :gutter="40">
        <Col span="24" v-if="company1">
        <div class="choicebox" :class="{ active: select.indexOf(0) !== -1 }" @click="changeArr(0)">
          <div class="select">已选择</div>
          <div class="choicebox-top" @click.stop="changeSelect(0)">
            <div class="txt1">{{ company1.name }}  {{ company1.nameEn }}</div>
            <div class="txt2">时间：{{ company1.startTime | moment("YYYY年MM月DD") }}{{ company1.endTime | moment("-DD日") }}&nbsp;&nbsp;&nbsp;{{ formatEventRange(company1.startTime, company1.endTime) }}
            </div>
            <!-- <div class="txt2">时间：{{ company1.startTime | moment("YYYY年MM月") }}
            </div> -->
            <div class="txt2">地点：{{ company1.address }}  China Import and Export Fair Complex</div>
               <div class="txt2">地址：{{ company1.exHall }}  No. 382, Yuejiang Zhong Road, Haizhu District, Guangzhou, Guangdong</div>
          </div>
          <div class="choicebox-tool">
            <span style="color:#f00">*</span>展位类型 Booth type：
            <RadioGroup v-model="companyInp1.areaType">
              <Radio label="光地 Raw Space"></Radio>
              <Radio label="标摊 Standard booth"></Radio>
            </RadioGroup>
            <span style="color:#f00;display:inline-block;margin-left:30px">*</span>预订面积 Booth area：
            <InputNumber v-model="companyInp1.showArea" :min="1" :max="9999">></InputNumber><span
              style="padding-left:5px">㎡</span>
          </div>
        </div>
        </Col>
        <Col span="12" v-if="company2">
        <div class="choicebox" :class="{ active: select.indexOf(1) !== -1 }" @click="changeArr(1)">
          <div class="select">已选择</div>
          <div class="choicebox-top" @click.stop="changeSelect(1)">
            <div class="txt1">{{ company2.name }}</div>
            <div class="txt2">时间：{{ company2.startTime | moment("YYYY年MM月DD") }}{{ company2.endTime | moment("-DD日") }}
            </div>
            <div class="txt2">地点：{{ company2.address }}</div>
            <div class="txt2">地址：{{ company2.exHall }}</div>
          </div>
          <div class="choicebox-tool">
            <span style="color:#f00">*</span>展位类型：
            <RadioGroup v-model="companyInp2.areaType">
              <Radio label="光地"></Radio>
              <Radio label="标摊"></Radio>
            </RadioGroup>
            <span style="color:#f00;display:inline-block;margin-left:30px">*</span>预订面积：
            <InputNumber v-model="companyInp2.showArea" :min="1" :max="9999">></InputNumber><span
              style="padding-left:5px">㎡</span>
          </div>
        </div>
        </Col>
      </Row>
    </div>
    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'register-entrance',
  data () {
    return {
      selectTypeArr: null,
      select: [],
      company1: null,
      company2: null,
      productName: '', // 参展展品 
      other: '',
      other2: '',
      areaName: '',
      areaIndex: 0,
      companyInp1: {
        showArea: 0,
        pType: 'RMB',
        exhibition: '',
      },
      companyInp2: {
        showArea: 0,
        pType: 'RMB',
        exhibition: '',
      },
      area1: [],
      area2: [],
      categoryArr: [],
      monthMap: {
          "01": "January",
          "02": "February",
          "03": "March",
          "04": "April",
          "05": "May",
          "06": "June",
          "07": "July",
          "08": "August",
          "09": "September",
          "10": "October",
          "11": "November",
          "12": "December"
      },
    };
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      GetAllProduct: 'registerdModule/GetAllProduct',
      getApplyCompanyGetAreas: 'registerdModule/getApplyCompanyGetAreas',
      getExhibitionById: 'registerdModule/getExhibitionById',
      getCategoryByGroupIdLevel: 'registerdModule/getCategoryByGroupIdLevel',
    }),


    formatEventRange(start, end) {
        const startM = moment(start).format("MM")
        const startD = moment(start).format("DD")

        const endD = moment(end).format("DD")
        const endY = moment(end).format("YYYY")

        return `${this.monthMap[startM]} ${startD}–${endD}, ${endY}`
    },

    async init () {
      this.getExhibitionHandle(); // 获取固定展会 
    },
    async getGetAllProduct (id) {
      let res = await this.GetAllProduct(id);
      //console.log('getGetAllProduct', res);
      if (res) {
        this.area1 = res;
        if (this.area1[0]) {
          this.areaName = this.area1[0].name || '';
        }
      }
    },
    async getExhibitionHandle () {
    //   let res = await this.getExhibitionById('D3DBE69A-CF4B-4CA0-AF71-909C481AB0FF');
    //   let res = await this.getExhibitionById('23D68EEB-A124-4109-A610-127F1042D1DA');
      // let res = await this.getExhibitionById('fd9ac1a3-665d-40ef-a378-8583b10e45a6'); // 94届
      // let res = await this.getExhibitionById('8e6d4e93-d846-464b-8413-2e2afa546bda'); // 95届
      let res = await this.getExhibitionById('134e88fb-aebe-4299-a0f8-28b7f0f1c1f7'); // 96届
      if (res) {
        this.company1 = res;
        this.getGetAllProduct(res.groupId); // 获取固定展会 
      }
      // let res2 = await this.getExhibitionById('875fcbc0-6c24-48b9-a1da-c83c0aec4919');
      // if (res) {
      //   this.company2 = res2;
      // }
      //console.log('res1', res);
    },
    async validHandle () {
      let exhibition = [];// 选中的展会
      if (!this.select.length) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }
      let arr = []; // 选中数组
      let errTxt = '';
      if (this.select.indexOf(0) !== -1) {
        exhibition.push(this.company1);
        this.companyInp1.exhibition = this.company1;
        arr.push(this.companyInp1);
      }
      if (this.select.indexOf(1) !== -1) {
        exhibition.push(this.company2);
        this.companyInp2.exhibition = this.company2;
        arr.push(this.companyInp2);
      }
      if (!this.areaName) {
        errTxt = "请选择展区";
      }
      if (!this.selectTypeArr) {
        
        errTxt = "请选择展区类型";
      }

      if (!errTxt) {
        arr.forEach(c => {
          if (!c.areaType) {
           
            errTxt = "请选择展位类型";
            return;
          }
          if (this.companyInp1.areaType === '标摊') {
            if (c.showArea) {
              if (c.showArea < 9) {
                errTxt = "标摊9平米起售、光地36平起售";
                return;
              }
            } else {
              errTxt = "请输入预定面积";
              return;
            }
          }
          if (this.companyInp1.areaType === '光地') {
            if (c.showArea) {
              if (c.showArea < 36) {
                errTxt = "标摊9平米起售、光地36平起售";
                return;
              }
            } else {
              errTxt = "请输入预定面积";
              return;
            }
          }
        });
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        return Promise.resolve({ valid: false });
      }
      let order = null;
      if (arr[0]) {
        order = {
          exhibitionId: arr[0].exhibition.id,
          pType: arr[0].pType,
          areaType: arr[0].areaType,
          showArea: arr[0].showArea,
        };
      }
      // let order2 = null;
      // if (arr[1]) {
      //   order2 = {
      //     exhibitionId: arr[1].exhibition.id,
      //     showArea: arr[1].showArea,
      //     pType: arr[1].pType,
      //     allMoney: 8 * arr[1].showArea,
      //     areaType: this.selectTypeArr,
      //     areaName: this.areaName,
      //   };
      // }
      let res = {
        ApplyCompanyOrder: order || {},
        // ApplyCompanyOrder2: order2 || {},
        exhibition: exhibition,
        comon: {
          deExHipkind: `${this.areaName}/${this.selectTypeArr.name}`
        }
      }
      //console.log('validHandle', res);
      return Promise.resolve({ valid: true, ...res });
    },
    changeArr (index) {
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      }
    },
    changeSelect (index) {
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      } else {
        this.select.splice(this.select.indexOf(index), 1);
      }
    },
    addType (item) {
      if (this.selectTypeArr && this.selectTypeArr.name === item.name) {
        this.selectTypeArr = null;
      } else {
        this.selectTypeArr = item;
      }
      //console.log('addType:', this.selectTypeArr);
    }
  },
}

</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #4f65ae !important;
    }

    .ivu-radio-inner:after {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-switch-checked {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;

    span {
      font-size: 14px;
    }
  }
}

.choice {
  margin-bottom: 30px;
}

.choicebox {
  background-color: #fff;
  border: solid 1px #e5e5e5;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &.active {
    background-color: #fdf7f9;
    border: solid 1px #4f65ae;

    .select {
      opacity: 1;
    }

    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #eff1f5;
        }
      }
    }

    .choicebox-tool {
      background-color: #eff1f5;
    }
  }

  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: -1px;
    right: -1px;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #4f65ae;
    font-size: 14px;
    color: #fff;
  }

  &-top {
    padding: 30px 30px 20px;
    background-color: #fff;

    .txt1 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .txt2 {
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
    }
  }

  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    border-top: solid 1px #e5e5e5;
    display: flex;
    align-items: center;
  }
}

.tabs {
  margin-bottom: 30px;

  &-top {
    color: #666;
    font-style: 18px;

    .tag {
      width: 270px;
      line-height: 48px;
      text-align: center;
      background-blend-mode: normal, normal;
      border-bottom: none;
      cursor: pointer;
      position: relative;
      border-left: solid 1px #4f9edd;
      border-right: solid 1px #4f9edd;
      border-top: solid 1px #4f9edd;
      border-radius: 5px 5px 0px 0px;
      overflow: hidden;
      /* 超出省略号 */
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 5px;

      span {
        position: relative;
        z-index: 1;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &:hover,
      &.active {
        background-color: transparent;
        color: #fff;

        &::before {
          background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
            linear-gradient(#f2f2f2, #f2f2f2);
        }
      }
    }
  }

  &-bottom {
    border: solid 1px #4f9edd;
    padding: 20px 20px 0;

    .item {
      cursor: pointer;
      width: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 32px;
      border-radius: 5px;
      background-color: #f7f7f7;
      color: #666;
      margin-bottom: 20px;
      overflow: hidden;
      padding: 0 5px;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.active {
        background-color: #4f9edd;
        color: #fff;
      }
    }
  }
}
</style>
